import { createFeatureSelector, createSelector } from "@ngrx/store";
import type { OrganizationState } from "./organization.models";

export const selectOrganizationState = createFeatureSelector<OrganizationState>('organization');

export const selectOrganization = createSelector(
  selectOrganizationState,
  state => state.data
);

export const selectAllOrganizations = createSelector(
  selectOrganizationState,
  state => state.allData
);

export const selectOrganizationError = createSelector(
  selectOrganizationState,
  state => state.error
);

export const selectOrganizationMessage = createSelector(
  selectOrganizationState,
  state => state.message
);

export const selectOrganizationSuccess = createSelector(
  selectOrganizationState,
  state => state.success
);

export const selectOrganizationValidationErrors = createSelector(
  selectOrganizationState,
  state => state.validationError
);
